export const s = {
  noPad: { marginLeft: 0, paddingLeft: 0 },
  marg: { margin: '16px 8px' },
  gallery: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'start',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  } as React.CSSProperties,
  main: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
  } as React.CSSProperties,
  title: {
    fontSize: '32px',
    fontWeight: 600,
    color: '#262626',
  },
  subhead: {
    fontSize: '16px',
    fontWeight: 400,
    color: '#262626',
  },
}

export const SUPPLIER_DEALS_CONTAINER_DIV: React.CSSProperties = {
  width: '100%',
  marginTop: '32px',
  marginBottom: '60px',
}
